// src/components/CookieConsentBanner.js
// Conforme GDPR + Google Consent Mode v2
import React, { useEffect, useState, useContext } from "react";
import { LangContext } from "../lang/LangProvider";
import "./CookieConsentBanner.css";

// Helper centralizzato per aggiornare lo stato GA via Consent Mode v2
function updateGAConsent(analyticsGranted) {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: analyticsGranted ? "granted" : "denied",
    });
  }
}

export default function CookieConsentBanner() {
  const { lang } = useContext(LangContext);
  const [showBanner, setShowBanner] = useState(false);

  const texts = {
    it: {
      title: "Cookie e Privacy",
      description:
        "Utilizziamo cookie essenziali per il funzionamento del sito e, con il tuo consenso, Google Analytics per migliorare l'esperienza. Consulta la nostra ",
      privacyLink: "Privacy Policy",
      acceptAll: "Accetta tutto",
      acceptEssential: "Solo essenziali",
      rejectAll: "Rifiuta analytics",
    },
    en: {
      title: "Cookies & Privacy",
      description:
        "We use essential cookies for site functionality and, with your consent, Google Analytics to improve your experience. See our ",
      privacyLink: "Privacy Policy",
      acceptAll: "Accept all",
      acceptEssential: "Essential only",
      rejectAll: "Reject analytics",
    },
  };

  const content = lang === "en" ? texts.en : texts.it;

  useEffect(() => {
    const saved = localStorage.getItem("cookie-consent");
    if (saved) {
      // Rispristina il consenso GA alla ricarica della pagina
      const parsed = JSON.parse(saved);
      updateGAConsent(parsed.analytics === true);
    } else {
      // Prima visita: mostra banner
      setShowBanner(true);
    }
  }, []);

  const saveConsent = (analytics) => {
    const consent = { essential: true, analytics, marketing: false, ts: Date.now() };
    localStorage.setItem("cookie-consent", JSON.stringify(consent));
    updateGAConsent(analytics);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-banner" role="alertdialog" aria-label="Cookie consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3 className="cookie-title">{content.title}</h3>
          <p className="cookie-description">
            {content.description}
            <a href={`/${lang}/privacy`} className="cookie-link">
              {content.privacyLink}
            </a>
            .
          </p>
        </div>
        <div className="cookie-buttons">
          <button className="cookie-btn cookie-btn-reject" onClick={() => saveConsent(false)}>
            {content.rejectAll}
          </button>
          <button className="cookie-btn cookie-btn-essential" onClick={() => saveConsent(false)}>
            {content.acceptEssential}
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={() => saveConsent(true)}>
            {content.acceptAll}
          </button>
        </div>
      </div>
    </div>
  );
}
